import { updatePartner360Configuration } from 'legacy/lut/services/partner360/configuration/updatePartner360Configuration'
import { map621ToMarketSector } from 'legacy/lut/services/partner360/marketInfo/mappings/map621ToMarketSector'
import { mapMarketSectorTo621 } from 'legacy/lut/services/partner360/marketInfo/mappings/mapMarketSectorTo621'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { requestRecalculateCompleteness } from '../../completeness'
import { selectFinancialYear, selectPartner360Data } from '../../configuration'
import { REQUEST_PARTNER360_UPDATE_PARTNER_MARKET_INFO } from '../constants'
import { IMarketSector } from '../models/IMarketInfo'

export const requestUpdatePartnerMarketInfo = createAsyncThunk<
  IMarketSector,
  Partial<IMarketSector>
>(REQUEST_PARTNER360_UPDATE_PARTNER_MARKET_INFO, async (form, { getState, dispatch }) => {
  const state = getState()
  const configuration = selectPartner360Data(state)
  const fYear = selectFinancialYear(state)

  const dataToUpdate = mapMarketSectorTo621(form)
  const updatedData = await updatePartner360Configuration({
    EntryId: configuration.entryId,
    PartnerId: configuration.partnerId,
    FYear: fYear,

    ...dataToUpdate,
  })

  await dispatch(
    requestRecalculateCompleteness({
      partnerId: configuration.partnerId,
      fYear,
    })
  )

  return map621ToMarketSector(updatedData)
})
